module.exports = __webpack_public_path__ + "img/1511448205.26a962d2.jpg";